import { ref } from 'vue'
import { Breakpoints } from '@shared/types/enums'
import { useEventListener } from '@shared/utils/composables/event-listener'

export function useResizeHandler() {
  const smAndDown = ref<boolean>(false)
  const smAndUp = ref<boolean>(false)
  const mdAndDown = ref<boolean>(false)
  const mdAndUp = ref<boolean>(false)
  const lgAndDown = ref<boolean>(false)
  const lgAndUp = ref<boolean>(false)
  const windowHeight = ref<number>(0)

  const onResize = () => {
    smAndDown.value = document.documentElement.clientWidth < Breakpoints.SM
    smAndUp.value = document.documentElement.clientWidth > Breakpoints.SM
    mdAndDown.value = document.documentElement.clientWidth < Breakpoints.MD
    mdAndUp.value = document.documentElement.clientWidth >= Breakpoints.MD
    lgAndDown.value = document.documentElement.clientWidth < Breakpoints.LG
    lgAndUp.value = document.documentElement.clientWidth > Breakpoints.LG
    windowHeight.value = window.innerHeight
  }

  useEventListener(window, 'resize', onResize, true)

  return { smAndDown, smAndUp, mdAndDown, mdAndUp, lgAndDown, lgAndUp, windowHeight }
}
